/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Rail_CategoriesInputs */

const en_directory_detail_rail_categories = /** @type {(inputs: Directory_Detail_Rail_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categories`)
};

const zh_directory_detail_rail_categories = /** @type {(inputs: Directory_Detail_Rail_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分类`)
};

/**
* | output |
* | --- |
* | "Categories" |
*
* @param {Directory_Detail_Rail_CategoriesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_rail_categories = /** @type {((inputs?: Directory_Detail_Rail_CategoriesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Rail_CategoriesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_rail_categories(inputs)
	return zh_directory_detail_rail_categories(inputs)
});
export { directory_detail_rail_categories as "directory.detail.rail.categories" }